export enum Country {
  Russia = "Russia",
}
